export default __webpack_public_path__ + "static/images/login/background2.cff0d09139afc59071e9f54ab1bea41c.png";